import { Button, Modal } from 'components/core';
import { FC } from 'react';
import { Styled, OrderErrorModalProps } from '.';
import { useI18n } from 'contexts/i18n';

export const OrderErrorModal: FC<OrderErrorModalProps> = ({ onClose }) => {
  const i18n = useI18n();
  return (
    <Modal>
      <Styled.ErrorContainer>
        <Styled.ErrorTitle>{i18n['Order Failed!']}</Styled.ErrorTitle>
        <Styled.ErrorMessage>
          {i18n['Oops! An error occoured while placing the order.']} <br />
          {i18n['You can try again or contact our support team.']}
        </Styled.ErrorMessage>
        <Button size="md" onClick={onClose}>
          {i18n['Close']}
        </Button>
      </Styled.ErrorContainer>
    </Modal>
  );
};
